import {
  selectCellStyle,
  selectCellNumberFormat,
  selectValidationRuleFromPosition,
} from '../../selectors/sheetSelector';
import { ValidationCriteria, ValidationRule } from '../../types';
import {
  convertArrayAreaAddressToArea,
  createArrayAreaAddressFromPosition,
} from '../../utils/area/area';
import { getCellVisibleValue } from '../../utils/cells/cellCRUD';
import { formatCellVisibleText } from '../cellHelpers/cellHelpers';
import { RowCellsProps, CellView } from './cellViewTypes';

export const getCellVisibleData = (
  props: RowCellsProps,
  ci: number | undefined,
  width: number | undefined
): ((ri: number) => Partial<CellView>) => {
  if (ci === undefined || width === undefined) return () => ({});

  const {
    cells,
    cellsReferences,
    numberFormatMatrix,
    numberFormats,
    stylesMatrix,
    styles,
    dataValidationMatrix,
    dataValidationsMap,
    dataValidationRules,
    zoom,
  } = props;

  // const padding = zoom * 1.7;

  return (ri: number) => {
    const position = {
      ci,
      ri,
    };
    const arrayAddress = createArrayAreaAddressFromPosition(position);

    let { isError, visibleValue } = getCellVisibleValue(cells, position);
    const style = selectCellStyle(stylesMatrix, styles, position, arrayAddress);
    const numberFormat = selectCellNumberFormat(
      numberFormatMatrix,
      numberFormats,
      position,
      arrayAddress
    );

    const dataValidation = selectValidationRuleFromPosition(
      dataValidationMatrix,
      dataValidationsMap,
      dataValidationRules,
      position,
      arrayAddress
    );

    if (dataValidation) {
      if (dataValidation.criteria === ValidationCriteria.CellRange) {
      }
    }

    // console.log("dataValidation", dataValidation)

    // if (numberFormat) {
    // const output = formatCellVisibleText(
    //   isError,
    //   visibleValue,
    //   width - padding,
    //   numberFormat
    // );
    // if (output.str) visibleValue = output.str.toString();
    // if (output.color) color = output.color;
    // if (output.align) horizontal = output.align;
    // }

    return {
      isError,
      value: visibleValue,
      style,
      numberFormat,
      dataValidation,
    };
  };
};

// const isCellLevelValidation = (dataValidation?: ValidationRule) => {
//   if (dataValidation) {
//     if (!dataValidation.markInvalidContent) return undefined;
//   }

//   return dataValidation;
// };
